/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { Dialog, Headline } from '@oneaudi/unified-web-components';
import { Content, ImprintContainer, ImprintText } from './style';
import { messages } from '../../../i18n/messages';
import type { Dealer } from '../PartnerBusinessCardTag';
import { useDialogTabControl } from '../../../lib/hooks-utils/useDialogTabControl';

interface ImprintProps {
  imprintData: string | Dealer[] | undefined;
  imprintRef: React.RefObject<HTMLDialogElement>;
  open: boolean;
  close: any;
}

export const ImprintModal: React.FC<ImprintProps> = ({ imprintData, imprintRef, open, close }) => {
  const closeRef = React.useRef<HTMLButtonElement | null>(null);

  const renderHTML = (rawHTML: string) =>
    React.createElement('span', { dangerouslySetInnerHTML: { __html: rawHTML } });

  const renderCorrectImprintData = (imprint: string | Dealer[]): React.ReactElement => {
    if (typeof imprint === 'object') {
      return (
        <>
          {imprint.map((imprintObj: Dealer) => (
            <ImprintText
              variant={{ type: 'copy', order: '1', style: 'normal' }}
              key={Math.random()}
              marginBottom
            >
              {imprintObj.name}
            </ImprintText>
          ))}
        </>
      );
    }
    return (
      <ImprintText variant={{ type: 'copy', order: '1', style: 'normal' }}>
        {renderHTML(imprintData as string)}
      </ImprintText>
    );
  };

  useDialogTabControl({
    dialogRef: imprintRef,
    focusTargetRef: closeRef,
  });

  return (
    <Dialog
      data-testid="imprint-modal"
      variant="focus-large"
      open={open}
      hasCloseButton
      onClose={close}
      onCloseButtonAriaLabel="close dialog"
    >
      <Content>
        <ImprintContainer data-testid="imprint-text">
          <Headline tag="h2" variant={{ type: 'headline', order: '2', weight: 'normal' }}>
            {useI18n(messages.imprintTitle)}
          </Headline>
          {imprintData && renderCorrectImprintData(imprintData)}
        </ImprintContainer>
      </Content>
    </Dialog>
  );
};

export default ImprintModal;
